import {
  Box,
  createStyles,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { withStyles } from "@material-ui/styles";
import { useAppDispatch, useAppSelector } from "app/hooks";
import {
  fetchListLessonByUser,
  selectFilterLessonListByUser,
  selectLessonListByUser,
} from "features/Home/pages/ListLesson/listLessonSlice";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useStyles from "./style";

export interface ITableCalendarProps {}

export default function TableCalendar(props: ITableCalendarProps) {
  const { t } = useTranslation();
  const classes = useStyles();
  const navigate = useNavigate();
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth() + 1);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints?.down("sm"));

  const arrayMonth = [
    { name: `${t("home.table.thang1") || "Tháng 01"}`, value: 1 },
    { name: `${t("home.table.thang2") || "Tháng 02"}`, value: 2 },
    { name: `${t("home.table.thang3") || "Tháng 03"}`, value: 3 },
    { name: `${t("home.table.thang4") || "Tháng 04"}`, value: 4 },
    { name: `${t("home.table.thang5") || "Tháng 05"}`, value: 5 },
    { name: `${t("home.table.thang6") || "Tháng 06"}`, value: 6 },
    { name: `${t("home.table.thang7") || "Tháng 07"}`, value: 7 },
    { name: `${t("home.table.thang8") || "Tháng 08"}`, value: 8 },
    { name: `${t("home.table.thang9") || "Tháng 09"}`, value: 9 },
    { name: `${t("home.table.thang10") || "Tháng 10"}`, value: 10 },
    { name: `${t("home.table.thang11") || "Tháng 11"}`, value: 11 },
    { name: `${t("home.table.thang12") || "Tháng 12"}`, value: 12 },
  ];

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const dispatch = useAppDispatch();

  const filter = useAppSelector(selectFilterLessonListByUser);
  const listLesson = useAppSelector(selectLessonListByUser);

  useEffect(() => {
    dispatch(
      fetchListLessonByUser({ ...filter, month: currentMonth, year: new Date().getFullYear() })
    );
  }, [dispatch, filter, currentMonth]);

  const handleOpenMenu = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeMonth = (month: number) => {
    setAnchorEl(null);
    setCurrentMonth(month);
  };

  const handleGoToAllLessons = () => {
    navigate("/lesson-month");
  };

  const handleLessonClick = (lesson: any) => {
    const lessonId = lesson?.lessionId || lesson?.lession?.id || lesson?.id;
    if (lessonId) {
      navigate(`/lesson/${lessonId}`);
    }
  };

  const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
      head: {
        backgroundColor: "#F8FAFC",
        color: "#0F172A",
        fontSize: 13,
        fontWeight: 800,
        borderRight: "1px solid #E2E8F0",
        borderBottom: "2px solid #E2E8F0",
      },
      body: {
        fontSize: 14,
        fontWeight: 500,
        color: "#334155",
        borderRight: "1px solid #F1F5F9",
      },
    })
  )(TableCell);

  return (
    <Box>
      <Table className={classes.header}>
        <TableHead>
          <TableRow>
            <TableCell align="center" width={isMobile ? "80px" : "180px"}>
              <Typography variant="subtitle2" className={classes.header__title}>
                {t("home.table.lichhoc") || "LỊCH HỌC"}
              </Typography>
            </TableCell>

            <TableCell align="center" style={{ flexGrow: 1 }}>
              <Box
                className={classes.header__filterMonth}
                aria-controls={anchorEl ? "menu-list-month" : undefined}
                aria-haspopup="true"
                onClick={handleOpenMenu}
              >
                <CalendarTodayIcon style={{ fontSize: 16, color: "#818CF8", marginRight: 6 }} />
                <Typography variant="subtitle2">
                  {t(`home.table.thang${currentMonth}`) || `Tháng ${currentMonth < 10 ? `0${currentMonth}` : currentMonth}`}
                </Typography>
                <ExpandMoreIcon />
              </Box>

              <Menu
                id="menu-list-month"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                getContentAnchorEl={null}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                className={classes.menu_listMonth}
              >
                {arrayMonth.map((month) => (
                  <MenuItem
                    key={month.value}
                    selected={month.value === currentMonth}
                    onClick={() => handleChangeMonth(month.value)}
                  >
                    {month.name}
                  </MenuItem>
                ))}
              </Menu>
            </TableCell>

            <TableCell
              align="center"
              width={isMobile ? "80px" : "180px"}
              onClick={handleGoToAllLessons}
              style={{ cursor: "pointer" }}
            >
              <Typography variant="subtitle2" className={classes.header__title}>
                {t("home.table.tatca") || "TẤT CẢ"}
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
      </Table>

      <TableContainer component={Paper} className={classes.table_container} elevation={0}>
        {listLesson?.content?.length > 0 ? (
          isMobile ? (
            <Box style={{ display: "flex", flexDirection: "column", gap: 8, padding: "12px", overflowY: "auto", maxHeight: 430 }}>
              {listLesson.content.map((lesson: any, index: number) => (
                <Box
                  key={index}
                  onClick={() => handleLessonClick(lesson)}
                  className={classes.mobileCard}
                >
                  {/* Top Row: Date & Status */}
                  <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                    <Typography style={{ fontSize: "0.85rem", fontWeight: 700, color: "#64748B" }}>
                      {String(lesson?.lession?.publishDate).slice(-2)}/
                      {String(lesson?.lession?.publishDate).slice(4, 6)}/
                      {String(lesson?.lession?.publishDate).slice(0, 4)}
                    </Typography>
                    {lesson?.watched ? (
                      <Box className={clsx(classes.status, classes.statusSuccess)}>
                        <CheckCircleIcon className={classes.status_checkIcon} />
                        {t("home.table.dathamgia") || "Đã tham gia"}
                      </Box>
                    ) : (
                      <Box className={clsx(classes.status, classes.statusMissed)}>
                        <HighlightOffIcon className={classes.status_clearIcon} />
                        {t("home.table.chuathamgia") || "Chưa tham gia"}
                      </Box>
                    )}
                  </Box>

                  {/* Middle Row: Lesson Title */}
                  <Typography style={{ fontWeight: 800, color: "#1E293B", fontSize: "0.95rem" }}>
                    {lesson?.lession?.lessionName}
                  </Typography>
                </Box>
              ))}
            </Box>
          ) : (
            <Table stickyHeader className={classes.table}>
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center" width="160px">
                    {t("home.table.ngay/thang/nam") || "NGÀY/THÁNG/NĂM"}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {t("home.table.tenbaihoc") || "TÊN BÀI HỌC"}
                  </StyledTableCell>
                  <StyledTableCell align="center" width="180px">
                    {t("home.table.trangthai") || "TRẠNG THÁI"}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {listLesson.content.map((lesson: any, index: number) => (
                  <TableRow
                    key={index}
                    hover
                    onClick={() => handleLessonClick(lesson)}
                    className={classes.rowClickable}
                  >
                    <StyledTableCell align="center" component="th" scope="row" style={{ fontWeight: 700, color: "#475569" }}>
                      {String(lesson?.lession?.publishDate).slice(-2)}/
                      {String(lesson?.lession?.publishDate).slice(4, 6)}/
                      {String(lesson?.lession?.publishDate).slice(0, 4)}
                    </StyledTableCell>
                    <StyledTableCell align="left" style={{ fontWeight: 600, color: "#0F172A" }}>
                      {lesson?.lession?.lessionName}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {lesson?.watched ? (
                        <Box className={clsx(classes.status, classes.statusSuccess)}>
                          <CheckCircleIcon className={classes.status_checkIcon} />
                          {t("home.table.dathamgia") || "Đã tham gia"}
                        </Box>
                      ) : (
                        <Box className={clsx(classes.status, classes.statusMissed)}>
                          <HighlightOffIcon className={classes.status_clearIcon} />
                          {t("home.table.chuathamgia") || "Chưa tham gia"}
                        </Box>
                      )}
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )
        ) : (
          <Box p={4} style={{ color: "#64748B", fontWeight: 600, textAlign: "center" }}>
            {t("home.table.hientaichuacobaihoc") || "Hiện tại chưa có bài học trong tháng này."}
          </Box>
        )}
      </TableContainer>
    </Box>
  );
}
